import request from './utils';

const urlPrefix = '/api/common';
const authUrlPrefix = '/api/auth';
const urls = {
  // Applications
  listApps: '/apps',
  addApp: '/apps',
  fetchApp: '/apps/<app_id>',
  editApp: '/apps/<app_id>',
  fetchAppUsers: '/apps/<app_id>/users',
  addAppUser: '/apps/<app_id>/users',

  // App auth settings
  fetchAppAuthSetting: '/apps/<app_id>/auth_settings',
  editAppAuthSetting: '/apps/<app_id>/auth_settings',

  // App Email Template
  fetchEmailTemplate: '/apps/<app_id>/email_templates',
  updateEmailTemplate: '/apps/<app_id>/email_templates',

  // App SMTP Settings
  fetchAppSMTP: '/apps/<app_id>/email_provider',
  updateAppSMTP: '/apps/<app_id>/email_provider',

  // Hamlet Users
  fetchHamletUsers: '/hamlet_users',
  addHamletUser: '/hamlet_users',
  userIsExist: '/apps/user/exist',

  // App manage
  authorizeAppManager: '/users/<user_id>/grant_apps',
  changeUserPassword: '/users/<user_id>/password',
  unlockUser: '/users/<user_id>/unlock',
  editUser: '/users/<user_id>',

  // Log events
  fetchEvents: '/events',
  searchLogs: '/logs',

};

const authUrls = {
};

const thirdparty = {
  // weixin
  weixin: '/thirdparty/weixin/connect',

  // Account
  unbindUserAccount: '/thirdparty/unbind/user/account',
};

Object.keys(urls).map((url) => {
  urls[url] = urlPrefix + urls[url];
  return url;
});

Object.keys(authUrls).map((url) => {
  authUrls[url] = authUrlPrefix + authUrls[url];
  return url;
});

export default new function API() {
  this.listApps = () => request.get(urls.listApps, {});
  this.addApp = param => request.post(urls.addApp, param);
  this.fetchApp = id => request.get(urls.fetchApp.replace('<app_id>', id));
  this.editApp = (id, param) => request.put(urls.editApp.replace('<app_id>', id), param);
  this.fetchAppUsers = id => request.get(urls.fetchAppUsers.replace('<app_id>', id));
  this.addAppUser = (id, param) => request.post(urls.addAppUser.replace('<app_id>', id), param);

  this.fetchAppAuthSetting = id => request.get(urls.fetchAppAuthSetting.replace('<app_id>', id));
  this.editAppAuthSetting = (id, param) => request.post(urls.editAppAuthSetting.replace('<app_id>', id), param);

  this.fetchEmailTemplate = id => request.get(urls.fetchEmailTemplate.replace('<app_id>', id));
  this.updateEmailTemplate = (id, param) => request.post(urls.updateEmailTemplate.replace('<app_id>', id), param);

  this.fetchAppSMTP = id => request.get(urls.fetchAppSMTP.replace('<app_id>', id));
  this.updateAppSMTP = (id, param) => request.post(urls.updateAppSMTP.replace('<app_id>', id), param);

  this.fetchHamletUsers = () => request.get(urls.fetchHamletUsers, {});
  this.addHamletUser = param => request.post(urls.addHamletUser, param);
  this.userIsExist = param => request.post(urls.userIsExist, param);

  this.authorizeAppManager = (id, param) => request.post(urls.authorizeAppManager.replace('<user_id>', id), param);
  this.changeUserPassword = (id, param) => request.post(urls.changeUserPassword.replace('<user_id>', id), param);
  this.unlockUser = id => request.post(urls.unlockUser.replace('<user_id>', id));
  this.editUser = (id, param) => request.put(urls.editUser.replace('<user_id>', id), param);

  this.fetchEvents = () => request.get(urls.fetchEvents);
  this.searchLogs = param => request.get(urls.searchLogs, param);

  this.loginByWeixin = param => request.post(thirdparty.weixin, param);

  // Account
  this.unbindUserAccount = param => request.post(thirdparty.unbindUserAccount, param);
}();



// WEBPACK FOOTER //
// ./src/api/index.js